import "./artists.css";

import React from "react";
import { Link } from "react-router-dom";

import { ROUTES } from "../../data/content";
import { getArtworksBy } from "../../data/gallery";
import ArtworkGrid from "../general/ArtworkGrid";
import PageMeta from "../general/PageMeta";
import PageTitle from "../general/PageTitle";

//An artist's bio, photo and artworks (one route per artist, on the Wix URLs)
const ArtistPage = ({ artist }) => {
  const artworks = React.useMemo(() => getArtworksBy(artist.slug), [artist.slug]);

  return (
    <div className={"page"}>
      <PageMeta
        title={artist.name}
        description={`${artist.bio[0].split(/(?<=\.)\s/)[0]} Bronze sculpture by ${artist.name} at The Charles Greig Gallery, Hyde Park Corner.`}
      />
      <PageTitle>Artists</PageTitle>

      <div className={"container"}>
        <section className={"title-box"}>
          <h2 className={"section-title"}>{artist.title}</h2>
        </section>

        <section className={"artist-intro"}>
          <div className={"artist-bio"}>
            {artist.bio.map((text) => (
              <p
                key={text}
                className={"body-text is-justified"}
              >
                {text}
              </p>
            ))}
          </div>
          <div className={"artist-photo"}>
            <img
              src={artist.photo}
              alt={`${artist.name} at work`}
              width={492}
              height={336}
            />
          </div>
        </section>

        <section
          className={"artist-artworks"}
          aria-labelledby={"artworks-title"}
        >
          <h2
            id={"artworks-title"}
            className={"section-title"}
          >
            Artworks
          </h2>
          <ArtworkGrid
            artworks={artworks}
            pageSize={12}
          />
          <p className={"artist-shop-link"}>
            <Link to={ROUTES.ALL_ARTWORKS}>Browse all artworks</Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default ArtistPage;
